/**
 * WalletPageRoute
 * Canon: SUPABANK CANON v1.3.0
 * 
 * TASK-003: Updated to use real WalletPage component instead of stub
 * 
 * References:
 * - CANON.md v1.3.0
 * - EPIC-001 (Auth → Onboarding → Dashboard)
 * - TASK-003-user-flow-canon-compliance.md
 */

import WalletPage from "@/components/wallet/WalletPage";

export default function WalletPageRoute() {
  return <WalletPage />;
}